import React from "react";
import PrintDetailedReport from "./printResults";

const PrintReportPage = () => {
  // Read both single-order and multi-order params from the URL
  const urlParams = new URLSearchParams(window.location.search);
  const testOrderId = urlParams.get("orderId");

  const orderIdsParam = urlParams.get("orderIds");
  const multiOrderIds = orderIdsParam
    ? orderIdsParam
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id !== "")
    : null;

  return (
    <div className="print-container">
      <PrintDetailedReport testOrderId={testOrderId} multiOrderIds={multiOrderIds} />
    </div>
  );
};

export default PrintReportPage;
